import Swiper from "swiper/bundle";


  const swiper = new Swiper(".section-inspiration-click-through-slider", {
    direction: "horizontal",
    loop: false,
    centeredSlides: false,
    spaceBetween: 24,
    navigation: {
      nextEl: ".swiper-button-next.inspiration-navigation",
      prevEl: ".swiper-button-prev.inspiration-navigation",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      425: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3.2,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });

